import {Injectable} from '@angular/core';
import { OneTimeAccessCodeMgtResource } from '@blcloud/bl-ng-resource';
import { IOneTimeAccessCodeMgt } from '@blcloud/bl-datamodel';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class RedirectPageService extends OneTimeAccessCodeMgtResource {

  /**
   * getAuth
   */
  getAuth(code: string): Observable<IOneTimeAccessCodeMgt> {
    // 400か404が返ってくる想定なので、 { ignoreAuthError: true } は不要
    return super.getById(code, {subject: 'common'}); // .map(res => res.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/page/redirect-page/redirect-page.service.ts